import { api } from "@/api"
import type {
  PaginatedResponse,
  PaginationQuery,
} from "@/utils/utilityTypes"

import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "@vueuse/core"

type MerchantGroupDetailTerminal = {
  id: string
  serialNumber: string
  lastPaired: Date | null
  lastTransactedAt: Date | null
}

export type ListMerchantGroupDetailTerminalsQuery =
  PaginationQuery & {
    schemaName: string
  }

const listMerchantGroupDetailTerminals = async (
  query: ListMerchantGroupDetailTerminalsQuery
): Promise<
  PaginatedResponse<MerchantGroupDetailTerminal>
> => {
  const { body } = await api.get<
    PaginatedResponse<
      RecursivelyConvertDatesToStrings<MerchantGroupDetailTerminal>
    >
  >(
    "/merchant-group/self/merchant-group-detail/terminals/",
    {
      query: query,
      isMerchantGroup: true,
    }
  )

  return {
    ...body,
    items: body.items.map((terminal) => ({
      ...terminal,
      lastPaired: terminal.lastPaired
        ? DateFns.parseISO(terminal.lastPaired)
        : null,
      lastTransactedAt: terminal.lastTransactedAt
        ? DateFns.parseISO(terminal.lastTransactedAt)
        : null,
    })),
  }
}

export const useMerchantGroupDetailTerminals = (
  query: MaybeRef<ListMerchantGroupDetailTerminalsQuery>
) =>
  useQuery({
    queryKey: [
      BASE_MERCHANT_GROUP_TERMINALS_QUERY_KEY,
      "detail",
      query,
    ] as const,
    queryFn: ({
      queryKey: [_basekey, _routekey, query_],
    }) => listMerchantGroupDetailTerminals(unref(query_)),
  })
